import { Pipe, PipeTransform } from '@angular/core';
import { WorkOrder, WorkOrderStatus } from '~gc/domains/work/work-order/work-order.model';

@Pipe({ name: 'isPublishedWithResponses' })
export class IsPublishedWithResponsesPipe implements PipeTransform {
  transform(workOrder: WorkOrder): boolean {
    return workOrder.status === WorkOrderStatus.PublishedWithResponses;
  }
}
